

import { CLAIMENT_DETAILS_SET_VALUE } from "../../../actions/kaMetlhaFuneralClaim/claimentDetails";
import { DECEASED_DETAILS_SET_VALUE } from "../../../actions/kaMetlhaFuneralClaim/deceasedDetails";
import { KM_CLAIM_UPLOAD_DOCUMENT } from "../../../actions/kaMetlhaFuneralClaim/uploadDocuments";
import { claimentDetailsValidation } from "./claimentDetails";
import { deceasedDetailsValidation } from "./deceasedDetails";
import { uploadDocumentsValidation } from "./uploadDocuments";

export const kaMetlhaFuneralClaimValidations = (store, next, action) => {

//   if (action.type.startsWith(PAYMENT_DETAILS_SET_VALUE)){
//       return paymentDetailsValidation(store, next, action);}
if (action.type.startsWith(KM_CLAIM_UPLOAD_DOCUMENT)) {
  return uploadDocumentsValidation(store, next, action);
}
  if (action.type.startsWith(CLAIMENT_DETAILS_SET_VALUE)) {

    return claimentDetailsValidation(store, next, action);
  }
  if (action.type.startsWith(DECEASED_DETAILS_SET_VALUE)) {

    return deceasedDetailsValidation(store, next, action);
  }
  
  return null;
};
